import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { ObservableDocumentExtension as ObservableDocumentModel } from 'tio-data/data/resources/observable-document.ext';
import type { Store } from '@warp-drive/core';

type RouteParams = {
  observable_document_id: number;
};

export default class AuthenticatedObservabilityDocumentsShow extends Route {
  @service declare store: Store;

  async model(params: RouteParams) {
    const id = params['observable_document_id'];

    const { content } = (await this.store.request(
      findRecord<ObservableDocumentModel>('observable-document', String(id), {
        include: 'observable-asset,observable-document-logs',
      })
    )) as { content: { data: ObservableDocumentModel } };
    return content.data;
  }
}
